import axios from "axios";


export async function Init() {

}
